'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _responsiveMixin = require('../util/responsiveMixin');

var _responsiveMixin2 = _interopRequireDefault(_responsiveMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var grey = '#cbd2d6';
var lightGrey = '#D6D6D6';
var checkmarkGreen = '#018065';
var vxDarkerGray = '#2c2e2f';
var vxAccessibleBlue = '#0070BA';

var PaymentInterstitialOverpanel = _react2.default.createClass({
	displayName: 'PaymentInterstitialOverpanel',

	mixins: [_responsiveMixin2.default],

	propTypes: {
		handleSubmitType: _react.PropTypes.func.isRequired,
		handleCloseLink: _react.PropTypes.func.isRequired,
		paymentType: _react.PropTypes.oneOf(['G&S', 'F&F']).isRequired,
		paymentContentHTML: _react.PropTypes.string.isRequired,
		note: _react.PropTypes.string.isRequired,
		mainContent: _react.PropTypes.shape({
			headerText: _react.PropTypes.string.isRequired,
			friendsAndFamily: _react.PropTypes.shape({
				title: _react.PropTypes.string.isRequired,
				blurb: _react.PropTypes.string.isRequired
			}).isRequired,
			goodsAndServices: _react.PropTypes.shape({
				title: _react.PropTypes.string.isRequired,
				recommended: _react.PropTypes.string.isRequired,
				blurb: _react.PropTypes.string.isRequired
			}).isRequired,
			footerNote: _react.PropTypes.string,
			PPPNote: _react.PropTypes.string.isRequired,
			save: _react.PropTypes.string.isRequired,
			close: _react.PropTypes.string.isRequired
		}).isRequired
	},

	getInitialState: function getInitialState() {
		return {
			selectedType: this.props.paymentType
		};
	},


	/**
  * Updates the state
  */
	handleTypeChange: function handleTypeChange(newType) {
		this.setState({
			selectedType: newType
		});
	},
	handleSubmitType: function handleSubmitType() {
		this.props.handleSubmitType(this.state.selectedType);
	},
	handleCloseLink: function handleCloseLink(event) {
		event.preventDefault();
		this.props.handleCloseLink();
	},
	render: function render() {
		var _this = this;

		// non-Styles styles
		var styles = {
			interstitialWrapper: {
				textAlign: 'center',
				padding: this.state.responsiveMixin.isSmall ? '50px 15px' : '50px',
				marginTop: '-25px'
			},
			headerText: {
				fontSize: '1.6em', // special request that this fold to two lines as little as possible
				marginBottom: '35px'
			},
			line: {
				width: '100%',
				height: '1px',
				backgroundColor: grey,
				margin: '10px 0'
			},
			inputWrapper: {
				textAlign: 'left',
				borderRadius: '5px',
				position: 'relative',
				padding: '10px 20px',
				cursor: 'pointer'
			},
			toggleOuter: {
				background: 'white',
				width: '30px',
				height: '30px',
				position: 'absolute',
				borderRadius: '50%',
				border: '1px solid ' + lightGrey,
				padding: '4px', // 4px, not 5px, because of the 1px border
				boxSizing: 'border-box'
			},
			toggleInner: {
				width: '20px',
				height: '20px',
				borderRadius: '50%',
				transition: 'all 300ms ease',
				backgroundColor: vxAccessibleBlue
			},
			inputDetailsWrapper: {
				overflow: 'auto',
				marginLeft: '50px'
			},
			inputTitle: {
				fontFamily: '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, sans-serif',
				fontSize: '1.33em',
				fontWeight: 'normal',
				margin: 0
			},
			typeBlurb: {
				margin: '8px 0 0',
				fontSize: '13px',
				color: vxDarkerGray,
				fontFamily: 'Helvetica, Arial, sans-serif'
			},
			recommendedWrapper: {
				margin: '10px 0'
			},
			recommendedBlurb: {
				marginLeft: '5px',
				fontSize: '13px',
				display: 'inline',
				lineHeight: '1.4'
			},
			checkmark: {
				color: checkmarkGreen
			},
			PPPLink: {
				color: vxAccessibleBlue,
				textDecoration: 'none'
			},
			saveBlurb: {
				fontFamily: 'Helvetica, Arial, sans-serif',
				fontSize: '13px',
				width: '80%',
				margin: '0 auto'
			},
			moreBlurb: {
				fontFamily: 'Helvetica, Arial, sans-serif',
				fontSize: '13px',
				marginTop: '18px'
			},
			button: {
				display: 'block',
				margin: '30px auto 20px',
				width: '100%'
			},
			close: {
				cursor: 'pointer',
				color: vxAccessibleBlue
			}
		};

		/**
   * This function checks for this.props.selectedType to return the correct styling for the typeWrapperStyling.
   * @param typeContext {String} a string which represents where the function is being used
   * @return {Object} The correct style object for the
   */
		var getTypeWrapperStyle = function getTypeWrapperStyle(typeContext) {
			var typeWrapperStyle = void 0;

			if (typeContext === _this.state.selectedType) {
				typeWrapperStyle = _extends({}, styles.inputWrapper, { background: '#f1f8fc', border: '1px solid #0070ba', padding: '9px 19px' });
			} else {
				typeWrapperStyle = styles.inputWrapper;
			}

			return typeWrapperStyle;
		};

		/**
   * Sets the correct background style for the inner circle on the toggle
   * @param typeContext {String} a string which represents where the function is being used
   * @return {Object} the toggleInner style
   */
		var getToggleInnerStyle = function getToggleInnerStyle(typeContext) {
			var transform = typeContext === _this.state.selectedType ? 'scale(1)' : 'scale(0)';
			return _extends({}, styles.toggleInner, { transform: transform });
		};

		return _react2.default.createElement(
			'div',
			{ ref: 'container', style: styles.interstitialWrapper },
			_react2.default.createElement(
				'h2',
				{ style: _extends({}, _styles2.default.ViewHeaderText, styles.headerText) },
				this.props.mainContent.headerText
			),
			_react2.default.createElement('div', { style: styles.line }),
			_react2.default.createElement(
				'div',
				{
					style: getTypeWrapperStyle('F&F'),
					onClick: function onClick() {
						return _this.handleTypeChange('F&F');
					}
				},
				_react2.default.createElement(
					'div',
					{
						style: styles.toggleOuter,
						onKeyUp: function onKeyUp(event) {
							if (event.keyCode === 13 || event.keyCode === 32) {
								// if it's the enter or space key
								_this.handleTypeChange('F&F');
							}
						},
						tabIndex: '0'
					},
					_react2.default.createElement('div', { style: getToggleInnerStyle('F&F') })
				),
				_react2.default.createElement(
					'div',
					{ style: styles.inputDetailsWrapper },
					_react2.default.createElement(
						'h3',
						{ style: styles.inputTitle },
						this.props.mainContent.friendsAndFamily.title
					),
					_react2.default.createElement(
						'p',
						{ style: styles.typeBlurb },
						this.props.mainContent.friendsAndFamily.blurb
					)
				)
			),
			_react2.default.createElement('div', { style: styles.line }),
			_react2.default.createElement(
				'div',
				{
					style: getTypeWrapperStyle('G&S'),
					onClick: function onClick() {
						return _this.handleTypeChange('G&S');
					}
				},
				_react2.default.createElement(
					'div',
					{
						style: styles.toggleOuter,
						onKeyUp: function onKeyUp(event) {
							if (event.keyCode === 13 || event.keyCode === 32) {
								// if it's the enter or space key
								_this.handleTypeChange('G&S');
							}
						},
						tabIndex: '0'
					},
					_react2.default.createElement('div', { style: getToggleInnerStyle('G&S') })
				),
				_react2.default.createElement(
					'div',
					{ style: styles.inputDetailsWrapper },
					_react2.default.createElement(
						'h3',
						{ style: styles.inputTitle },
						this.props.mainContent.goodsAndServices.title
					),
					_react2.default.createElement(
						'div',
						{ style: styles.recommendedWrapper },
						_react2.default.createElement('span', { style: styles.checkmark, className: 'icon icon-small icon-positive-small', 'aria-hidden': true }),
						_react2.default.createElement(
							'p',
							{ style: styles.recommendedBlurb },
							this.props.mainContent.goodsAndServices.recommended
						)
					),
					_react2.default.createElement(
						'p',
						{ style: styles.typeBlurb },
						this.props.mainContent.goodsAndServices.blurb
					)
				)
			),
			_react2.default.createElement('div', { style: styles.line }),
			this.props.mainContent.footerNote && _react2.default.createElement(
				'p',
				{ style: styles.saveBlurb },
				this.props.mainContent.footerNote
			),
			_react2.default.createElement('p', { style: styles.moreBlurb, dangerouslySetInnerHTML: { __html: this.props.mainContent.PPPNote } }),
			_react2.default.createElement(
				'button',
				{
					type: 'button',
					onClick: this.handleSubmitType,
					style: styles.button,
					className: 'vx_btn' },
				this.props.mainContent.save
			),
			_react2.default.createElement(
				'a',
				{ href: '', onClick: this.handleCloseLink, style: styles.close },
				this.props.mainContent.close
			)
		);
	}
});

exports.default = PaymentInterstitialOverpanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/PaymentInterstitialOverpanel.js
// module id = 474
// module chunks = 6